export const getPlayIconPosition = (aspectRatio, isCustomWebsite) => {
  if (isCustomWebsite && aspectRatio < 100) return '30%';
  return '50%';
};

export const getImageDimensions = (aspectRatio, isCustomWebsite) => {
  const imageDimensionsObj = {
    width: '480px',
    height: '480px',
  };
  if (!isCustomWebsite) {
    imageDimensionsObj.height = 'auto';
  }
  if (aspectRatio > 100 && isCustomWebsite) {
    imageDimensionsObj.width = '480px';
    imageDimensionsObj.height = '270px';
  }
  if (aspectRatio < 100 && isCustomWebsite) {
    imageDimensionsObj.width = '392px';
    imageDimensionsObj.height = '697px';
  }
  return imageDimensionsObj;
};

export const getThumbnailImageDimensions = (aspectRatio, isCustomWebsite) => {
  const imageDimensionsObj = {
    height: '48px',
    width: '48px',
  };
  if (aspectRatio > 100 && isCustomWebsite) {
    imageDimensionsObj.width = '48px';
    imageDimensionsObj.height = '27px';
  }
  if (aspectRatio < 100 && isCustomWebsite) {
    imageDimensionsObj.width = '27px';
    imageDimensionsObj.height = '48px';
  }
  return imageDimensionsObj;
};

export const getEnlargedImageContainerDimensions = (aspectRatio, isCustomWebsite) => {
  const imageDimensionsObj = {
    height: '100%',
    width: '100%',
  };
  if (aspectRatio < 100 && isCustomWebsite) {
    imageDimensionsObj.width = '200%';
    imageDimensionsObj.height = '80%';
  }
  return imageDimensionsObj;
};

export const getZoomedImageDimension = (aspectRatio, isCustomWebsite) => {
  const imageDimensionsObj = {
    width: 1000,
    height: 1000,
  };
  if (aspectRatio > 100 && isCustomWebsite) {
    imageDimensionsObj.width = 1000;
    imageDimensionsObj.height = 560;
  }
  if (aspectRatio < 100 && isCustomWebsite) {
    imageDimensionsObj.width = 1000;
    imageDimensionsObj.height = 1800;
  }
  return imageDimensionsObj;
};
